export default __webpack_public_path__ + "3f8d45c57508b8ee7e6ae597e2379af9.svg";